import { ShiftNeed } from '@umss/shared/data-access';
import {
  ScopeOfPracticeEnum,
  ShiftStatusEnum,
  ShiftTypeEnum
} from '@umss/shared/utils';

/**
 * Mock shift needs data for development and testing
 * Used as fallback when backend API is unavailable
 * Note: scopeOfPractice and shiftType are numbers (backend format)
 */
export const MOCK_SHIFT_NEEDS: ShiftNeed[] = [
  {
    id: '1',
    facilityId: 'facility-1',
    facilityName: 'St. Judes Hospital',
    facilitySubtypeId: 1,
    facilitySubtypeName: 'ICU',
    scopeOfPractice: ScopeOfPracticeEnum.Cna, // CNA
    scopeOfPracticeDisplay: 'CNA',
    shiftType: ShiftTypeEnum.Regular, // Regular
    shiftTypeDisplay: 'Regular',
    shiftDate: '2025-06-19',
    startTime: '06:00',
    endTime: '18:00',
    numberOfPositions: 2,
    hourlyRate: 23.0,
    specialInstructions: 'ICU experience preferred',
    status: ShiftStatusEnum.Posted, // Posted
    statusDisplay: 'Open',
    postedByName: 'John Manager',
    estimatedHours: 12,
    estimatedPayment: 408.0,
    isUrgent: false,
    isExpired: false,
    createdAt: '2025-06-01T10:00:00Z',
    updatedAt: '2025-06-01T10:00:00Z'
  },
  {
    id: '2',
    facilityId: 'facility-2',
    facilityName: 'General Hospital',
    facilitySubtypeId: 2,
    facilitySubtypeName: 'Emergency Room',
    scopeOfPractice: ScopeOfPracticeEnum.Lpn, // LPN
    scopeOfPracticeDisplay: 'LPN',
    shiftType: ShiftTypeEnum.Urgent, // Urgent
    shiftTypeDisplay: 'Urgent',
    shiftDate: '2025-08-30',
    startTime: '14:00',
    endTime: '02:00',
    numberOfPositions: 1,
    hourlyRate: 34.0,
    specialInstructions: 'Emergency room coverage needed urgently',
    status: ShiftStatusEnum.Posted, // Posted
    statusDisplay: 'Open',
    postedByName: 'Sarah Admin',
    estimatedHours: 12,
    estimatedPayment: 408.0,
    isUrgent: true,
    isExpired: false,
    createdAt: '2025-08-25T14:00:00Z',
    updatedAt: '2025-08-25T14:00:00Z'
  },
  {
    id: '3',
    facilityId: 'facility-1',
    facilityName: 'St. Judes Hospital',
    facilitySubtypeId: 3,
    facilitySubtypeName: 'Surgical Unit',
    scopeOfPractice: ScopeOfPracticeEnum.Rn, // RN
    scopeOfPracticeDisplay: 'RN',
    shiftType: ShiftTypeEnum.Regular, // Regular,
    shiftTypeDisplay: 'Regular',
    shiftDate: '2025-06-20',
    startTime: '06:00',
    endTime: '18:00',
    numberOfPositions: 1,
    hourlyRate: 45.0,
    specialInstructions: 'Surgical unit',
    status: ShiftStatusEnum.Posted, // Open
    statusDisplay: 'Open',
    postedByName: 'Mike Supervisor',
    estimatedHours: 12,
    estimatedPayment: 540.0,
    isUrgent: false,
    isExpired: false,
    createdAt: '2025-06-01T10:00:00Z',
    updatedAt: '2025-06-01T10:00:00Z'
  },
  {
    id: '4',
    facilityId: 'facility-3',
    facilityName: 'City Medical Center',
    facilitySubtypeId: 4,
    facilitySubtypeName: 'Geriatric Ward',
    scopeOfPractice: ScopeOfPracticeEnum.Cna, // CNA
    scopeOfPracticeDisplay: 'CNA',
    shiftType: ShiftTypeEnum.Regular, // Regular
    shiftTypeDisplay: 'Regular',
    shiftDate: '2025-07-15',
    startTime: '22:00',
    endTime: '06:00',
    numberOfPositions: 3,
    hourlyRate: 25.0,
    specialInstructions: 'Night shift, geriatric ward',
    status: ShiftStatusEnum.Posted, // Open
    statusDisplay: 'Open',
    postedByName: 'Lisa Coordinator',
    estimatedHours: 8,
    estimatedPayment: 200.0,
    isUrgent: false,
    isExpired: false,
    createdAt: '2025-07-01T09:00:00Z',
    updatedAt: '2025-07-01T09:00:00Z'
  },
  {
    id: '5',
    facilityId: 'facility-2',
    facilityName: 'General Hospital',
    facilitySubtypeId: 5,
    facilitySubtypeName: 'Pediatric Unit',
    scopeOfPractice: ScopeOfPracticeEnum.Lpn, // LPN
    scopeOfPracticeDisplay: 'LPN',
    shiftType: ShiftTypeEnum.Urgent, // Urgent
    shiftTypeDisplay: 'Urgent',
    shiftDate: '2025-06-25',
    startTime: '06:00',
    endTime: '14:00',
    numberOfPositions: 1,
    hourlyRate: 32.0,
    specialInstructions: 'Pediatric unit, urgent coverage needed',
    status: ShiftStatusEnum.Posted, // Open
    statusDisplay: 'Open',
    postedByName: 'Dr. Smith',
    estimatedHours: 8,
    estimatedPayment: 256.0,
    isUrgent: true,
    isExpired: false,
    createdAt: '2025-06-23T16:00:00Z',
    updatedAt: '2025-06-23T16:00:00Z'
  }
];
